import React, { useState, useEffect, useRef } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { useAuth } from "../../../context/AuthProvider";
import { Link } from "react-router-dom";
import ViewStockReport from "./ViewStockReport";
import handleError from "../../../constants/handleError";
import ReactPaginate from "react-paginate";
import Messages from "../../../constants/Messages";
import { toPrimaryQuantity } from "@heartinz/finance";
import { ChevronRightIcon, DownloadIcon, SearchIcon, SpreadSheetIcon } from "../../../constants/Icons";

const StockReport = () => {
  const wrapperRef = useRef(null);

  const { isUser } = useAuth();
  const showAlert = useShowAlert();
  const [productSearchTerm, setProductSearchTerm] = useState("");
  const [productSuggestions, setProductSuggestions] = useState([]);
  const [showProductDropdown, setShowProductDropdown] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isStockEditModalOpen, setStockEditModalOpen] = useState(false);
  const [isStockOutModalOpen, setStockOutModalOpen] = useState(false);
  const suggestionsRef = useRef(null);
  const { checkNetwork } = useNetwork();
  const debounceTimerRef = useRef(null);
  const requestIdRef = useRef(0);
  const controllerRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 50;
  const [inputValue, setInputValue] = useState("");
  const [allStores, setAllStores] = useState([]);
  const [allSuggestions, setAllSuggestions] = useState([]);
  const [showStorePopup, setShowStorePopup] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const StoreSuggestionsRef = useRef(null);
  const suggestionRefs = useRef([]);
  const [selectedStoreDeta, setSelectedStoreDeta] = useState("");

  const MAIN_STORE = {
    _id: isUser.storeId,
    title: isUser.title,
    stype: isUser.stype,
    email: isUser.email,
  };

  const [selectedStore, setSelectedStores] = useState(MAIN_STORE._id);
  var obj = {
    label: isUser.title,
    value: isUser.storeId,
    stype: isUser.stype,
  };

  const [isPreLoading, setPreLoading] = useState(true);
  const [isBtnLoading, setBtnLoading] = useState(false);
  const storeSelectedRef = useRef(null);

  const [isStockReportData, setStockReportData] = useState([]);

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const primaryQuanity=(quanity,unitData)=>{
    const qty=toPrimaryQuantity(quanity, unitData);
    return qty?.primaryQty;
  }

  const closeEditModal = () => {
    setStockEditModalOpen(false);
  };

  const closeStockOutModal = () => {
    setStockOutModalOpen(false);
  };
  const handleUpdate = async (updatedData) => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData.productid,
        // stockid: updatedData._id,
        ...(updatedData?.manufacturedate && {
          manufacturedate: DateConverter.convertToTimeZone(
            updatedData?.manufacturedate,
            isUser.timezone,
          ),
        }),
        ...(updatedData?.expiredate && {
          expiredate: DateConverter.convertToTimeZone(
            updatedData?.expiredate,
            isUser.timezone,
          ),
        }),
        mrp: CurrencyConverter.toSubunit(updatedData.mrp, "INR"),
        saleprice: CurrencyConverter.toSubunit(updatedData.saleprice, "INR"),
        taxpercentage: updatedData.taxpercentage,
        // discount: CurrencyConverter.toSubunit(updatedData.discount, "INR"),
        baseprice: CurrencyConverter.toSubunit(updatedData.baseprice, "INR"),
        taxamount: CurrencyConverter.toSubunit(updatedData.taxamount, "INR"),
        isLock: updatedData.isLock,
        landingcost: CurrencyConverter.toSubunit(
          updatedData.landingcost || 0,
          "INR",
        ),
      };
      const response = await AxiosInstance.patch(
        `module/stock/${updatedData.stockid}`,
        data,
      );
      var index = updatedData.cIndex;
      const updatedDatas = response.data.results;

      setStockReportData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedDatas?.stockLinkId
            ? { ...item, ...updatedDatas }
            : item,
        ),
      );
      const stockValue = updatedData?.isSecondaryUnit
        ? primaryQuanity(updatedData?.stock, updatedData?.unitConfig)
        : updatedData?.stock;
      if (stockValue > 0.0) {
        if (updatedData.stockLeft < stockValue) {
          await handleStockIn(updatedData);
        } else if (updatedData.stockLeft >= stockValue) {
          if (updatedData.stockLeft >= stockValue) {
            await handleStockTrash(updatedData);
          } else {
            console.log("insufficient Stock");
          }
        } else {
          console.log("euql");
        }
      }
      showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      closeEditModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockTrash = async (updatedData, quantity, remarks) => {
    // console.log(updatedData);
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        stockid: updatedData?.stockid,
        // stocklid: updatedData.stocklid,
        // ...(remarks && { remarks }),
        remarks: "Stock Trashed",
        // quantity: Number((updatedData.stockLeft - updatedData?.stock).toFixed(3)),
        quantity: Number(updatedData?.isSecondaryUnit ?
          ((updatedData?.stockLeft - primaryQuanity(updatedData?.stock,updatedData?.unitConfig)).toFixed(3)):
          (updatedData?.stockLeft - updatedData?.stock).toFixed(3),
        ),
      };
      const response = await AxiosInstance.delete(
        `module/stock/trash/${updatedData?.stockLinkId}`,
        { data },
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      setStockReportData((prevStock) =>
        prevStock.map((item) =>
          item?.stockLinkId === updatedData?.stockLinkId
            ? {
                ...item,
                stockLeft: Number((item?.stockLeft - updatedData?.quantity).toFixed(3)),
              }
            : item,
        ),
      );

      // showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
      // closeStockOutModal();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleStockIn = async (updatedData, quantity) => {
    // setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const data = {
        productid: updatedData?.productid,
        // stockid: updatedData._id,
        stocklinkid: updatedData?.stockLinkId,
        // quantity: Number((updatedData?.stock - updatedData?.stockLeft).toFixed(3)),
        quantity : Number(updatedData?.isSecondaryUnit ?
          ((primaryQuanity(updatedData?.stock,updatedData?.unitConfig) - updatedData?.stockLeft ).toFixed(3)):
          (updatedData?.stock - updatedData?.stockLeft).toFixed(3),
        ),
      };
      const response = await AxiosInstance.patch(
        `module/stock/stockin/${updatedData?.stockid}`,
        data,
      );
      var index = updatedData.cIndex;
      updatedData = response.data.results;

      // setStockData((prevStock) => {
      //   if (prevStock[index]?._id === updatedData._id) {
      //     const updatedStock = [...prevStock];
      //     updatedStock[index] = { ...prevStock[index], ...updatedData };
      //     return updatedStock;
      //   }
      //   return prevStock.map((item) =>
      //     item._id === updatedData._id ? { ...item, ...updatedData } : item
      //   );
      // });

      setStockReportData((prevStock) =>
        prevStock.map((item) =>
          item?.stockid === updatedData?.stockid
            ? {
                ...item,
                stockIn: updatedData?.stockIn,
                stockLeft: updatedData?.stockLeft,
              }
            : item,
        ),
      );
      // showAlert("success", Messages.SUCCESS.STOCK_UPDATED);
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleListStore = async () => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`list-substore`);
      // const options = formatOptions(response.data.results, isUser.stype);
      const stores = response.data?.results || [];

      const mergedStores = [MAIN_STORE, ...stores];

      setAllStores(mergedStores);
      // setInputValue(MAIN_STORE.title);
      setSelectedStores("");
      // const userStore = options.find(
      //   (option) => option.value === isUser.storeId
      // );
      // setSelectedStore(userStore);
      // handleSaleReport();
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPreLoading(false);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!value.trim()) {
      setSelectedStores(MAIN_STORE._id);
      setAllSuggestions(allStores);
      setShowStorePopup(false);
      return;
    }

    const filtered = allStores.filter((store) =>
      store.title.toLowerCase().includes(value.toLowerCase()),
    );

    setAllSuggestions(filtered);
    setShowStorePopup(true);
  };

  const handleSelectStores = (store) => {
    const displayText = `${store?.title} - ${store?.email}`;
    setInputValue(displayText);
    setSelectedStores(store?._id);
    setShowStorePopup(false);
    setSelectedStoreDeta(store);
  };

  const handleSuggestionNavigation = (e) => {
    if (!showStorePopup || allSuggestions.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < allSuggestions.length - 1 ? prev + 1 : 0,
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : allSuggestions.length - 1,
      );
    }

    if (e.key === "Enter") {
      if (activeIndex >= 0) {
        e.preventDefault();
        handleSelectStores(allSuggestions[activeIndex]);
      }
    }

    if (e.key === "Escape") {
      setShowStorePopup(false);
    }
  };

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  const handleOutsideClick = (e) => {
    if (
      StoreSuggestionsRef.current &&
      !StoreSuggestionsRef.current.contains(e.target)
    ) {
      setShowStorePopup(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  const getColor = (status) => {
    switch (status.toLowerCase()) {
      case "main":
        return "bg-label-orange";
      case "sub":
        return "bg-label-peach";
      case "hub":
        return "bg-label-night";
      default:
        return "bg-label-secondary";
    }
  };

  const exportToCSV = () => {
    if (!isStockReportData?.length) {
      showAlert("warning", "No data available to export");
      return;
    }

    // 1. Headers
    const headers = `S No,Date,Time,SKU Code,Title,MRP,Sale Price,Tax(%),Landing Cost,Expire,Stock In,Stock Left`;

    const clean = (val) => (val ?? "").toString().replace(/[\r\n,;]/g, " ");

    // 2. Rows
    const rows = isStockReportData
      .map((item, index) => {
        const expireDate = item.expiredate
          ? DateConverter.ISOToDisplayFormat(
              DateConverter.convertToTimeZone(
                item.expiredate,
                isUser?.timezone,
              ),
            ).date
          : "";

        const row = [
          index + 1,
          clean(
            DateConverter.ISOToDisplayFormat(
              DateConverter.convertToTimeZone(item.createdAt, isUser.timezone),
            ).date,
          ),
           clean(
            DateConverter.ISOToDisplayFormat(
              DateConverter.convertToTimeZone(item.createdAt, isUser.timezone),
            ).time,
          ),
          clean(item?.code),
          clean(item?.title),
          clean(CurrencyConverter.toCurrency(item?.mrp || 0, "INR")),
          clean(CurrencyConverter.toCurrency(item?.saleprice || 0, "INR")),
          clean(item?.taxpercentage ?? 0),
          clean(CurrencyConverter.toCurrency(item?.landingcost || 0, "INR")),
          clean(expireDate),
          clean(item?.stockIn ?? 0),
          clean(item?.stockLeft ?? 0),
        ];
        return row.join(",");
      })
      .join("\n");

    // 3. Combine headers and rows
    const csvContent = [headers, rows].join("\n");

    // 4. Create blob and trigger download
    const BOM = "\uFEFF";
    const blob = new Blob([BOM + csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Stock_Report_${
      new Date().toISOString().split("T")[0]
    }.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleProductSearch = (term) => {
    setProductSearchTerm(term);

    if (term.trim() === "") {
      setProductSuggestions([]);
      setShowProductDropdown(false);
      setSelectedProduct(null);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    debounceTimerRef.current = setTimeout(async () => {
      try {
        setPreLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;

        const response = await AxiosInstance.get(
          `module/product/search-hybrid-active?searchtxt=${term}`,
          { signal: controllerRef.current.signal },
        );

        if (currentId === requestIdRef.current) {
          const results = response.data.results || [];
          setProductSuggestions(results);
          setShowProductDropdown(results.length > 0);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          console.error("API Error:", error);
        }
      } finally {
        setPreLoading(false);
      }
    }, 200);
  };

  const handleSelectProduct = (product) => {
    setSelectedProduct(product);
    setProductSearchTerm(product.title);
    setShowProductDropdown(false);
  };

  const handleProductKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) =>
        Math.min(prev + 1, productSuggestions.length - 1),
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();

      if (highlightedIndex >= 0) {
        const selected = productSuggestions[highlightedIndex];
        handleSelectProduct(selected);
        setShowProductDropdown(false);
        setHighlightedIndex(-1);
      }
    }
  };

  const handleGenerateStock = async (page = 0) => {
    setPreLoading(true);
    try {
      if (!checkNetwork()) return;
      let url = `module/reports/stock/${selectedStore}?pageno=${
        page + 1
      }&limit=${perPage}`;

      // if (selectedStore){
      //   url +=`&storeId=${selectedStore}`
      // }

      const response = await AxiosInstance.get(url);
      const result = response.data.results;
      setStockReportData(result);
      if (result.length === 0) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(response.data.totalPages || 0);
        setTotalItems(response.data.totalItems || 0);
      }
      setPreLoading(false);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setPreLoading(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowProductDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selectedStore) {
      handleGenerateStock(currentPage);
    }
  }, [currentPage]);
  useEffect(() => {
    {
      isUser?.stype === "MAIN" ? handleListStore() : setAllStores([MAIN_STORE]);
    }
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="page-content">
          <div className="page-breadcrumb d-flex align-items-center paddingBottom">
            <div className="breadcrumb-title pe-3">Stock Report</div>
            <div className="ms-auto">
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-export dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <DownloadIcon/> Export
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" onClick={exportToCSV}>
                      <SpreadSheetIcon/>{" "}
                      <span className="icon-text">Excel (CSV)</span>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3 align-items-end">
                    <div className="col-lg-4 col-12">
                      <div className="position-relative">
                        <div className="input-group" ref={StoreSuggestionsRef}>
                          <input
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            value={inputValue}
                            onFocus={(e) => {
                              e.target.select();
                              setAllSuggestions(allStores);
                              if (allSuggestions.length > 0)
                                setShowStorePopup(true);
                            }}
                            onChange={(e) => {
                              handleChange(e);
                              setActiveIndex(-1);
                            }}
                            onKeyDown={handleSuggestionNavigation}
                            placeholder="Search Outlet.."
                          />
                          <button className="input-group-text">
                            <SearchIcon/>
                          </button>
                        </div>
                        {showStorePopup && allSuggestions.length > 0 && (
                          <ul
                            className="suggestions-list"
                            style={{ maxHeight: "150px" }}
                          >
                            {allSuggestions.map((store, index) => (
                              <li
                                key={store._id}
                                ref={(el) =>
                                  (suggestionRefs.current[index] = el)
                                }
                                onMouseDown={() => handleSelectStores(store)}
                                className={`suggestion-item ${activeIndex === index ? "active-suggestion" : ""}`}
                              >
                                {store.title} -{" "}
                                <span className="badge badge-primary badge bg-label-sea rounded-pill">
                                  {store.email}
                                </span>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>

                    <div className="col-2 float-end">
                      <div className="d-grid">
                        {isBtnLoading ? (
                          <button
                            className="btn btn-primary pb-0 text-right"
                            disabled
                          >
                            <CircularProgress
                              size={22}
                              className="text-white"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            id="salesreportbtn"
                            onClick={() => handleGenerateStock(currentPage)}
                          >
                            Generate <ChevronRightIcon/>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row g-3 align-items-end">
                    <div
                      className="col-4"
                      ref={wrapperRef}
                      style={{ position: "relative" }}
                    >
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="search"
                          ref={suggestionsRef}
                          autoComplete="off"
                          value={productSearchTerm}
                          onChange={(e) => {
                            handleProductSearch(e.target.value);
                            setShowProductDropdown(true);
                            setHighlightedIndex(0);
                          }}
                          onKeyDown={handleProductKeyDown}
                          onFocus={() => {
                            if (productSuggestions.length > 0) {
                              setShowProductDropdown(true);
                            }
                          }}
                          placeholder="Search products by hsnsac, title..."
                          autoFocus
                        />
                        <button className="input-group-text">
                          <i className="bx bx-search"></i>
                        </button>
                      </div>
                      {productSearchTerm && productSuggestions.length === 0 && (
                        <ul className="suggestions-list">
                          <li className="suggestion-item text-muted">
                            No products data was found
                          </li>
                        </ul>
                      )}
                      {showProductDropdown && productSuggestions.length > 0 && (
                        <ul className="suggestions-list">
                          {productSuggestions.map((product, index) => (
                            <li
                              ref={(el) => (suggestionRefs.current[index] = el)}
                              key={product._id}
                              onClick={() => handleSelectProduct(product)}
                              className={`suggestion-item ${
                                highlightedIndex === index ? "highlighted" : ""
                              }`}
                            >
                              <span className="badge rounded-pill bg-label-navy">
                                {product.code}
                              </span>{" "}
                              - {product.title} -{" "}
                              <span className="badge bg-label-fall rounded-pill">
                                ₹
                                {CurrencyConverter.toCurrency(
                                  product.saleprice || 0,
                                  "INR"
                                )}
                              </span>
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>

                    <div className="col-2 float-end">
                      <div className="d-grid">
                        {isBtnLoading ? (
                          <button
                            className="btn btn-primary pb-0 text-right"
                            disabled
                          >
                            <CircularProgress
                              size={22}
                              className="text-white"
                            />
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-primary"
                            id="salesreportbtn"
                            onClick={() => handleGenerateStock(selectedProduct)}
                          >
                            Generate <i className="bx bx-chevron-right"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="col-lg-12">
              <div className="">
                <ViewStockReport
                  isData={isStockReportData}
                  isLoading={isBtnLoading}
                  isPreLoading={isPreLoading}
                  setStockEditModalOpen={setStockEditModalOpen}
                  closeEditModal={closeEditModal}
                  handleUpdate={handleUpdate}
                  isStockEditModalOpen={isStockEditModalOpen}
                  setStockOutModalOpen={setStockOutModalOpen}
                  isStockOutModalOpen={isStockOutModalOpen}
                  closeStockOutModal={closeStockOutModal}
                  handleStockTrash={handleStockTrash}
                />
                {/* {totalPages > 0 && (
                  <div className="d-flex justify-content-center mt-1">
                    <ReactPaginate
                      previousLabel={"← Previous"}
                      nextLabel={"Next →"}
                      breakLabel={"..."}
                      onPageChange={({ selected }) => {
                        setBtnLoading(true);
                        setCurrentPage(selected);
                      }}
                      pageRangeDisplayed={5}
                      pageCount={totalPages}
                      containerClassName="pagination"
                      pageClassName="page-item"
                      pageLinkClassName="page-link"
                      previousClassName="page-item"
                      previousLinkClassName="page-link"
                      nextClassName="page-item"
                      nextLinkClassName="page-link"
                      breakClassName="page-item"
                      breakLinkClassName="page-link"
                      activeClassName="active"
                      forcePage={currentPage}
                    />
                  </div>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockReport;
